// import { BrowserRouter } from ;
import { ConnectedRouter } from 'connected-react-router';
import React from 'react';
import config from '../../data/config';
import getTenant from '../../utils/getTenant';
import Cookies from 'universal-cookie';
import store from '../../store';
import { push } from 'connected-react-router';

const usingBrowserHistory = config.router === 'browser';

let createChosenHistory = usingBrowserHistory
  ? require('history').createBrowserHistory
  : require('history').createHashHistory;

const cookies = new Cookies();

var tenant = getTenant();
var cookieTenant = cookies.get('tenant');
var pathPiece = window.location.pathname.split('/')[1];

if (!tenant) {
  pathPiece = pathPiece.toLowerCase();
  if (pathPiece !== 'home' && pathPiece !== 'dsconnected' && pathPiece !== 'dssigned') {
    setTimeout(function () {
      cookies.remove(`auth-header-${getTenant()}`, { path: '/' });
      cookies.set('is-saml', '', { path: '/' });
      store.dispatch(push('/no_tenant'));
    }, 1000);
  }
} else if (!cookieTenant) {
  cookies.set('tenant', tenant, { path: '/' });
} else if (cookieTenant !== tenant) {
  cookies.set('tenant', tenant, { path: '/' });
  cookies.remove(`auth-header-${cookieTenant}`, { path: '/' });
  cookies.remove(`auth-header-${getTenant()}`, { path: '/' });
}

let history = createChosenHistory({ basename: '/' + tenant });

if (process.env.NODE_ENV === 'test') {
  history = require('history').createMemoryHistory({
    initialEntries: ['/welcome']
  });
}

/**
 * SPA client navigations do not update document.referrer. We track the last in-app
 * location so BackButton can avoid blind fallbacks when moving e.g. list → detail.
 */
function tenantRelativePathForBack(pathname) {
  const parts = pathname.split('/').filter(Boolean);
  if (parts.length >= 2) {
    return '/' + parts.slice(1).join('/');
  }
  return pathname.startsWith('/') ? pathname : `/${pathname}`;
}

let lastTrackedPathWithSearch = null;
let spaPreviousTenantRelativePath = null;

function pathWithSearchFromLocation(loc) {
  return loc.pathname + (loc.search || '');
}

lastTrackedPathWithSearch = pathWithSearchFromLocation(history.location);

history.listen(location => {
  const next = pathWithSearchFromLocation(location);
  if (lastTrackedPathWithSearch !== null && next !== lastTrackedPathWithSearch) {
    const prevPathname = lastTrackedPathWithSearch.split('?')[0];
    spaPreviousTenantRelativePath = tenantRelativePathForBack(prevPathname);
  }
  lastTrackedPathWithSearch = next;
});

/** Path (tenant-relative) we navigated from on the last in-app transition, or null if unknown. */
export function getSpaPreviousTenantRelativePath() {
  return spaPreviousTenantRelativePath;
}

export default history;

// TODO organize files
export const Router = ({ children }) => (
  <ConnectedRouter history={history}>{children}</ConnectedRouter>
);
